import clsx from 'clsx'
import {toAbsoluteUrl} from '../../helpers'

type FormErrorProps = {
  message: string
  className?: string
}
export const FormError = ({message, className = ''}: FormErrorProps) => {
  return (
    <div className={clsx('fv-plugins-message-container d-flex gap-1', className)}>
      <img alt='err' src={toAbsoluteUrl('/media/gori/common/invalid.svg')} width={16} height={20} />
      <div className='fv-help-block text-danger'>
        <span role='alert'>{message}</span>
      </div>
    </div>
  )
}
